import styled from "@emotion/styled";

export type StatusType = "success" | "warning" | "error" | "default";

const getStatusType = (status: string): StatusType => {
  const upperStatus = status.toUpperCase();
  if (upperStatus === "COMPLETED") return "success";
  if (upperStatus === "IN_PROGRESS") return "warning";
  if (upperStatus === "ERROR") return "error";
  return "default";
};

const Badge = styled.span<{ statusType: StatusType }>`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  background-color: ${({ statusType }) => {
    switch (statusType) {
      case "success":
        return "#dcfce7";
      case "warning":
        return "#fef3c7";
      case "error":
        return "#fee2e2";
      default:
        return "#f3f4f6";
    }
  }};
  color: ${({ statusType }) => {
    switch (statusType) {
      case "success":
        return "#166534";
      case "warning":
        return "#92400e";
      case "error":
        return "#991b1b";
      default:
        return "#374151";
    }
  }};
`;

const StatusDot = styled.span<{ statusType: StatusType }>`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${({ statusType }) => {
    switch (statusType) {
      case "success":
        return "#22c55e";
      case "warning":
        return "#f59e0b";
      case "error":
        return "#ef4444";
      default:
        return "#9ca3af";
    }
  }};
`;

interface StatusBadgeProps {
  status: string;
  showDot?: boolean;
}

export const StatusBadge = ({ status, showDot = true }: StatusBadgeProps) => {
  const statusType = getStatusType(status);
  const displayText = status.replace(/_/g, " ");

  return (
    <Badge statusType={statusType}>
      {showDot && <StatusDot statusType={statusType} />}
      {displayText}
    </Badge>
  );
};
